/*
 * @Author: huangzq
 * @Date: 2020-04-26 17:17:37
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-26 17:29:31
 * @Desc: 仅供查看的
*/
<template>
  <div class="readonly-span">
    {{ value }}
  </div>
</template>

<script>
export default {
  name: 'ReadonlySpan',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>

<style lang='scss' scoped>
.readonly-span {
  color: #262626;
}
</style>
